import gql from "graphql-tag";
import {client} from "./client";
import {IContactNode, IEntityNode, IGeometryNode} from "../types";
import {RequestEntitiesAndContactsByLayerType} from "../../schema/RequestEntitiesAndContactsByLayerType";

/*
    *
    *
    *    LayerName
    *    Name
    *    MemberType
    *    WebsiteURL
    *    POCID
    *    Notes
    *    PubConInfo
    *    Instruc
    *    DateLastChanged
    *    Geometry
    *
    * */

/**
 *
 * TODO: use paging
 *
 * */

type result = {
    layerByType: {
        type: string
        layername: string
        entitiesByLayerid: {
            nodes: Array<IEntityNode & {
                entitycontactsByFullUid: {
                    nodes: Array<IContactNode>
                }
                entitygeometryByFullUid: IGeometryNode
            }>
        }
    }
}

const baseContact = {
    pocid: undefined,
    cell: "",
    datelastchanged: "",
    document: "",
    email: "",
    instruc: "",
    land: "",
    name: "",
    pubconinfo: ""
};

type mappedResult = Partial<IEntityNode> & {
    contact?: Partial<IContactNode>
    geometry?: string
    fid2?: string
    type?: string
    geoType?: string
    objectid?: number
    pocids?: string
}

function mapResult (layerByType: result['layerByType']):
    {data: Array<mappedResult>, errors: any[]} {
    const data: Array<mappedResult> = [];
    const errors: any = [];
    layerByType.entitiesByLayerid.nodes.forEach((node) => {
        try {
            const newNode = {
                ...node,
                entitycontactsByFullUid: undefined,
                entitygeometryByFullUid: undefined,
                contact: baseContact,
                geometry: node.entitygeometryByFullUid.theGeom,
                fid2: node.entitygeometryByFullUid.fid2,
                objectid: node.entitygeometryByFullUid.objectid,
                type: node.entitygeometryByFullUid.type,
                geoType: node.entitygeometryByFullUid.geoType,
                layername: layerByType.layername,
                pocids: '',
            };
            if (node.entitycontactsByFullUid.nodes.length === 0) {
                data.push(newNode);
            }
            const pocids = node.entitycontactsByFullUid.nodes.map(node => node.contactByPocid.pocid).join(';');
            while (node.entitycontactsByFullUid.nodes.length > 0) {
                const entityContact = node.entitycontactsByFullUid.nodes.pop();
                const contact = entityContact?.contactByPocid;
                const newContactNode = {...newNode, pocids, contact};
                data.push(newContactNode);
            }
        } catch (e) {
            errors.push(node);
        }
    });
    // console.log(result);
    return {data, errors};
}

export async function requestEntitiesAndContactsByLayerType (type: string):
    Promise<ReturnType<typeof mapResult>['data']> {
    try {
        const result: {data: result} = await client.query({
            query: gql`${RequestEntitiesAndContactsByLayerType}`,
            variables: {
                type,
            }
        });
        // console.log(result);
        const {data, errors} = mapResult(result.data.layerByType);
        if (errors.length > 0) {
            console.warn('Error creating rows for nodes', errors);
        }
        return data;
    } catch (e) {
        console.error(e);
        return [] as any;
    }
}
